// src/constants/VEB/vebConfig.ts
import { FormField } from "../@types/plan.types";

export const VEBConfig: FormField[] = [
	{
		name: "plan_name",
		label: "Plan Name",
		type: "text",
		required: true,
		is_present: true,
		is_visible_in_form: true,
		step: 1
	},
	{
		name: "carrier_name",
		label: "Carrier Name",
		type: "text",
		required: true,
		is_present: true,
		is_visible_in_form: true,
		step: 1
	},
	{
		name: "plan_code",
		label: "Plan Code",
		type: "text",
		required: true,
		is_present: true,
		is_visible_in_form: true,
		step: 1
	},
	{
		name: "plan_year",
		label: "Plan Year",
		type: "number",
		required: true,
		is_present: true,
		is_visible_in_form: true,
		step: 1
	},
	{
		name: "status",
		label: "Plan Status",
		type: "select",
		options: ["ACTIVE", "INACTIVE"],
		required: true,
		is_present: true,
		is_visible_in_form: true,
		step: 1
	},
	{
		name: "employee_class",
		label: "Employee Class",
		type: "select",
		options: ["ALL", "PT - Part Time", "FT - Full Time", "PTIN - Part Time Insurance Eligible"],
		required: true,
		is_present: true,
		is_visible_in_form: true,
		step: 1
	},
	{
		name: "plan_order",
		label: "Enter your desired plan order",
		type: "number",
		required: true,
		is_present: true,
		is_visible_in_form: true,
		step: 1
	},
	{
		name: "start_date",
		label: "Start Date",
		type: "date",
		required: true,
		is_present: true,
		is_visible_in_form: true,
		step: 1
	},
	{
		name: "end_date",
		label: "End Date",
		type: "date",
		is_present: true,
		is_visible_in_form: true,
		step: 1
	},
	{
		name: "auto_approve",
		label: "Auto Approve",
		type: "checkbox",
		required: false,
		is_present: true,
		is_visible_in_form: true,
		step: 1
	},
	{
		name: "Beneficiaries",
		label: "Does This Plan Require Beneficiaries?",
		type: "checkbox",
		required: false,
		is_present: true,
		is_visible_in_form: true,
		step: 1
	},
	{
		name: "deduction_code",
		label: "Deduction Code",
		type: "text",
		// required: true,
		// is_present: true,
		// is_visible_in_form: true,
		step: 1
	},
	{
		name: "document",
		label: "Plan Document (PDF)",
		type: "file",
		required: false,
		is_present: true,
		accept: ".pdf",
		is_visible_in_form: true,
		step: 1
	},
	{
		name: "indenpendent_relationship",
		label: "Do you have different age criteria or benefit for this plan for each relation?",
		type: "checkbox",
		required: false,
		is_present: true,
		is_visible_in_form: true,
		step: 2
	},
	{
		name: "employee_require",
		label: "Is Employee Enrollment Required for This Plan?",
		type: "checkbox",
		required: false,
		is_present: true,
		is_visible_in_form: true,
		step: 2
	},

	{
		name: "coverage_for",
		label: "Who should be covered by this insurance plan?",
		type: "multiselect",
		options: [
			"Employee Only",
			"Spouse Only",
			"Children Only",
			"Employee & Spouse",
			"Employee & Children",
			"Employee & Family",
			"Spouse & Children"
		],
		is_present: true,
		is_visible_in_form: true,
		required: true,
		step: 2
	},
	{
		name: "coverage_volume_present",
		label: "Do you have the coverage volume?",
		type: "checkbox",
		is_present: true,
		is_visible_in_form: true,
		step: 2
	},
	{
		name: "coverage_volume",
		label: "Enter Coverage Volume",
		condition: { field: "coverage_volume_present", value: true },
		type: "array",
		placeholder: "Enter coverage volume",
		is_present: true,
		is_visible_in_form: true,
		required: true,
		step: 2
	},
	{
		name: "coverage_volume_same_as_employee",
		label: "Must Each Dependent Take the Same Coverage Volume as the Employee?",
		condition: { field: "coverage_volume_present", value: true },
		type: "checkbox",
		placeholder: "Enter coverage volume",
		// is_present: true,
		// is_visible_in_form: true,
		// required: true,
		step: 2
	},
	{
		name: "pay_frequency",
		label: "How often would you like your VEB plan to be paid?",
		type: "multiselect",
		options: ["WEEKLY", "BIWEEKLY", "MONTHLY"],
		is_present: true,
		is_visible_in_form: true,
		step: 2,
		required: true
	},
	{
		name: "depends_on_standard_plan",
		label: "Does this plan depend on another standard plan?",
		type: "checkbox",
		is_present: false,
		is_visible_in_form: true,
		step: 2
	},
	{
		name: "standard_plan_dependency",
		label: "Select the standard plan(s) this plan depends on",
		type: "dropdown-with-meta",
		optionsKey: "activePlans",
		options: [],
		condition: { field: "depends_on_standard_plan", value: true },
		is_present: false,
		is_visible_in_form: true,
		step: 2
	},
	{
		name: "depends_on_rider_plan",
		label: "Does this plan depend on any rider plan?",
		type: "checkbox",
		is_present: false,
		is_visible_in_form: true,
		step: 2
	},
	{
		name: "rider_plan_dependency",
		label: "Select the rider plan(s) this plan depends on",
		type: "dropdown-with-meta",
		optionsKey: "activeRiderPlans",
		options: [],
		condition: { field: "depends_on_rider_plan", value: true },
		is_present: false,
		is_visible_in_form: true,
		step: 2
	},
	{
		name: "has_dependent_eligibility",
		label: "Does each relationship have dependent eligibility?",
		type: "checkbox",
		is_present: false,
		is_visible_in_form: true,
		step: 2
	},
	{
		name: "is_premium_depends_on_smoke",
		label: "Does the Premium Vary Based on Smoking Status?",
		type: "checkbox",
		is_present: false,
		is_visible_in_form: true,
		step: 2
	},

	{
		name: "isdependent_eligibility",
		label: "Are dependents eligible under this plan?",
		type: "checkbox",
		is_present: false,
		is_visible_in_form: true,
		step: 3
	},

	{
		name: "dependent_eligibility",
		label: "Dependent Eligibility",
		type: "meta",
		is_present: false,
		is_visible_in_form: true,
		condition: { field: "isdependent_eligibility", value: true },
		fields: [
			{
				name: "eligible_relationship",
				label: "Select Relationships Eligible for This Plan",
				type: "multiselect",
				options: ["SPOUSE", "CHILD", "STEP CHILD", "COURT-ORDER-DEPENDENT", "GRANDCHILD"],
				required: true,

				step: 3
			},
			{
				name: "spouse",
				label: "Spouse",
				type: "meta",

				condition: { field: "dependent_eligibility.eligible_relationship", includes: "SPOUSE" },
				fields: [
					{ name: "min_age", label: "Min Age", type: "number", defaultValue: 18, step: 4 },
					{ name: "max_age", label: "Max Age", type: "number", defaultValue: 100, step: 4 },
					{
						condition: { field: "is_benefit", value: true },
						name: "can_spouse_has_max_benefit_amount_than_employee",
						label: "Can the spouse's benefit exceed the employee's benefit?",
						type: "checkbox",
						step: 3
					}
				],
				step: 3
			},
			{
				name: "children",
				label: "Children",
				type: "meta",
				condition: { field: "dependent_eligibility.eligible_relationship", includes: "CHILD" },
				required: true,

				fields: [
					{ name: "min_age", label: "Min Age", type: "number", defaultValue: 0, step: 4 },
					{ name: "max_age", label: "Max Age", type: "number", defaultValue: 26, step: 4 },
					{
						name: "can_children_has_max_benefit_amount_than_employee",
						condition: { field: "is_benefit", value: true },

						label: "Can a child's benefit exceed the employee's benefit?",
						type: "checkbox",
						step: 3
					}
				],
				step: 3
			},
			{
				name: "disabled",
				label: "Disabled Children Details",
				type: "meta",
				condition: { field: "dependent_eligibility.eligible_relationship", includes: "CHILD" },

				fields: [
					{ name: "min_age", label: "Min Age", type: "number", defaultValue: 0, step: 4 },
					{ name: "max_age", label: "Max Age", type: "number", defaultValue: 100, step: 4 },

					{
						name: "children_can_exceed_employee_benefit",
						condition: { field: "is_benefit", value: true },

						label: "Can a disabled child's benefit exceed the employee's benefit?",
						type: "checkbox",
						step: 3
					}
				],
				step: 3
			}
		],
		step: 3
	},

	{
		name: "employee_eligibility",
		label: "Enter the eligibility of the employee",
		is_present: false,
		is_visible_in_form: true,
		type: "meta",
		fields: [
			{ name: "min_age", label: "Min Age", type: "number", step: 4, defaultValue: 16 },
			{ name: "max_age", label: "Max Age", type: "number", step: 4, defaultValue: 100 }
		],
		step: 4
	},
	{
		name: "is_this_plan_has_age_criteria",
		label: "Does this plan have age-based eligibility criteria?",
		type: "checkbox",
		is_present: true,
		is_visible_in_form: true,
		step: 4
	},
	{
		name: "age_criteria",
		type: "meta",
		label: "Age criteria",
		is_present: false,
		is_visible_in_form: true,
		condition: { field: "is_this_plan_has_age_criteria", value: true },
		fields: [
			{
				name: "use_age_bands",
				label: "Does this plan contain predefined age bands?",
				condition: { field: "age_criteria.enable_specific_ages", value: true, not: true },
				type: "checkbox",
				step: 4
			},
			{
				name: "age_band_ranges",
				label: "Enter the predefined age bands",
				type: "array",
				condition: { field: "age_criteria.use_age_bands", value: true },
				required: true,
				step: 4
			},
			{
				name: "enable_specific_ages",
				label: "Does this plan contain exact ages?",
				type: "checkbox",
				condition: { field: "age_criteria.use_age_bands", value: true, not: true },
				step: 4
			},
			{
				name: "min_age",
				label: "Min age",
				type: "number",
				required: true,
				condition: { field: "age_criteria.enable_specific_ages", value: true },
				step: 4
			},
			{
				name: "max_age",
				label: "Max Age",
				type: "number",
				required: true,
				condition: { field: "age_criteria.enable_specific_ages", value: true },
				step: 4
			}
		],
		step: 4
	},

	{
		name: "is_benefit",
		label: "Does this plan include a benefit amount?",
		type: "checkbox",
		is_present: true,
		is_visible_in_form: true,
		step: 5
	},
	{
		name: "benefit_amount",
		type: "meta",
		label: "Benefit Amount",
		is_present: true,
		is_visible_in_form: true,
		condition: { field: "is_benefit", value: true },
		step: 5,
		fields: [
			{
				name: "enable_specific_benefit",
				label: "Does this plan contain an exact benefit amount?",
				type: "checkbox",
				condition: { field: "benefit_amount.use_predefine_benefit", value: true, not: true },
				step: 5
			},
			{
				name: "min_benefit",
				label: "Min Benefit",
				type: "number",
				required: true,
				condition: { field: "benefit_amount.enable_specific_benefit", value: true },
				step: 5
			},
			{
				name: "each_benefit_multiply_by",
				label: "Step",
				type: "number",
				condition: { field: "benefit_amount.enable_specific_benefit", value: true },
				step: 5
			},
			{
				name: "max_benefit",
				label: "Max Benefit",
				type: "number",
				required: true,
				condition: { field: "benefit_amount.enable_specific_benefit", value: true },
				step: 5
			},
			{
				name: "benefit_amount_round_to_nearest",
				label: "Round benefit amount to nearest (e.g. 1000)",
				type: "number",
				condition: { field: "benefit_amount.enable_specific_benefit", value: true },
				step: 5
			},

			{
				name: "use_predefine_benefit",
				label: "Do you have specific predefined benefit amounts?",
				type: "checkbox",
				condition: { field: "benefit_amount.enable_specific_benefit", value: true, not: true },
				step: 5
			},
			{
				name: "benefit_band_ranges",
				label: "Enter the predefined benefit amounts",
				type: "array",
				required: true,
				condition: { field: "benefit_amount.use_predefine_benefit", value: true },
				step: 5
			},

			{
				name: "is_benefit_based_on_salary",
				label: "Is the benefit amount based on employee salary?",
				type: "checkbox",
				step: 5
			},
			{
				name: "is_benefit_amount_based_on_yearly_salary_percentage",
				label: "Use a percentage of annual salary",
				type: "checkbox",
				condition: [
					{ field: "benefit_amount.is_benefit_based_on_salary", value: true },
					{
						field: "benefit_amount.is_benefit_amount_based_on_yearly_salary_multiplier",
						value: true,
						not: true
					}
				],
				step: 5
			},
			{
				name: "salary_percentage",
				label: "Salary Percentage (e.g. 50 = 50% of annual salary)",
				type: "number",
				required: true,

				condition: {
					field: "benefit_amount.is_benefit_amount_based_on_yearly_salary_percentage",
					value: true
				},
				step: 5
			},
			{
				name: "is_benefit_amount_based_on_yearly_salary_multiplier",
				label: "Use a multiplier of annual salary",
				type: "checkbox",
				condition: [
					{ field: "benefit_amount.is_benefit_based_on_salary", value: true },
					{
						field: "benefit_amount.is_benefit_amount_based_on_yearly_salary_percentage",
						value: true,
						not: true
					}
				],
				conditionOperator: "AND",

				step: 5
			},
			{
				name: "yearly_salary_multiplier",
				label: "Yearly salary multiplier",
				type: "number",
				required: true,
				condition: {
					field: "benefit_amount.is_benefit_amount_based_on_yearly_salary_multiplier",
					value: true
				},
				step: 5
			},
			{
				name: "salary_multiplier_max_cap",
				label: "Maximum Benefit Cap on Salary Multiplier",
				type: "number",
				condition: {
					field: "benefit_amount.is_benefit_amount_based_on_yearly_salary_multiplier",
					value: true
				},
				step: 5
			},
			{
				name: "is_each_member_has_different_benefit_amount",
				label: "Does Each Dependent Have a Different Benefit Amount or Age Criteria?",
				type: "checkbox",
				condition: [
					{ field: "dependent_eligibility.eligible_relationship", includes: "SPOUSE" },
					{ field: "dependent_eligibility.eligible_relationship", includes: "CHILD" }
				],
				conditionOperator: "OR",
				step: 5
			},

			{
				name: "spouse",
				type: "meta",
				label: "Spouse",
				// is_present: true,
				// is_visible_in_form: true,

				condition: [
					{ field: "dependent_eligibility.eligible_relationship", includes: "SPOUSE" },
					{ field: "benefit_amount.is_each_member_has_different_benefit_amount", value: true },
					{ field: "coverage_for", includes: "Spouse Only" }
				],
				conditionOperator: "AND",
				step: 5,
				fields: [
					{
						name: "is_premium_depends_on_smoke",
						label: "Does the premium depend on  smoke?",
						type: "checkbox",
						// is_present: false,
						// is_visible_in_form: true,
						step: 5
					},
					{
						name: "spouse_can_enroll_individually",
						label: "Does Spouse individually enroll in this plan?",
						type: "checkbox",
						// is_present: false,
						// is_visible_in_form: true,
						step: 5
					},

					{
						name: "use_predefine_benefit",
						label: "Do you have specific predefined benefit amounts?",
						type: "checkbox",
						condition: { field: "benefit_amount.spouse.enable_specific_benefit", value: true, not: true },
						step: 5
					},
					{
						name: "enable_specific_benefit",
						label: "Does this plan contain an exact benefit amount?",
						type: "checkbox",
						condition: { field: "benefit_amount.spouse.use_predefine_benefit", value: true, not: true },
						step: 5
					},
					{
						name: "min_benefit",
						label: "Min Benefit (Spouse)",
						condition: {
							field: "benefit_amount.spouse.use_predefine_benefit",
							value: true
						},
						required: true,
						type: "number",
						step: 5
					},
					{
						name: "each_benefit_multiply_by",

						condition: {
							field: "benefit_amount.spouse.use_predefine_benefit",
							value: true
						},
						label: "Step (Spouse)",
						type: "number",
						required: true,
						step: 5
					},
					{
						name: "max_benefit",
						condition: {
							field: "benefit_amount.spouse.use_predefine_benefit",
							value: true
						},
						label: "Max Benefit (Spouse)",
						type: "number",
						required: true,
						step: 5
					},
					{
						name: "options",
						condition: {
							field: "benefit_amount.spouse.enable_specific_benefit",
							value: true
						},
						label: "Predefined benefit options (Spouse)",
						type: "array",
						required: true,
						step: 5
					},
					// Salary
					{
						name: "is_benefit_based_on_salary",
						label: "Is spouse benefit based on employee salary?",
						type: "checkbox",
						step: 5
					},
					{
						name: "salary_multiplier",
						label: "Salary Multiplier (Spouse)",
						type: "number",
						condition: { field: "benefit_amount.spouse.is_benefit_based_on_salary", value: true },
						step: 5
					},
					{
						name: "salary_multiplier_max_cap",
						label: "Maximum Benefit Cap on Salary Multiplier (Spouse)",
						type: "number",
						condition: { field: "benefit_amount.spouse.is_benefit_based_on_salary", value: true },
						step: 5
					},
					{
						name: "can_spouse_benefit_exceed_employee",
						label: "Can spouse benefit exceed employee benefit?",
						type: "checkbox",
						step: 5
					},
					// Age eligibility
					{
						name: "premium_depend_on_age",
						label: "Does this plan premium depndent on the spouse age?",
						condition: { field: "benefit_amount.spouse.enable_specific_ages", value: true, not: true },
						type: "checkbox",
						step: 5
					},
					{
						name: "use_age_bands",
						label: "Does this plan contain predefined age bands?",
						condition: [
							{ field: "benefit_amount.spouse.enable_specific_ages", value: true, not: true },
							{ field: "benefit_amount.spouse.premium_depend_on_age", value: true }
						],
						conditionOperator: "AND",
						type: "checkbox",
						step: 5
					},
					{
						name: "age_band_ranges",
						label: "Enter the predefined age bands",
						type: "array",
						condition: { field: "benefit_amount.spouse.use_age_bands", value: true },
						required: true,
						step: 5
					},
					{
						name: "enable_specific_ages",
						label: "Does this plan contain exact ages?",
						type: "checkbox",
						condition: { field: "benefit_amount.spouse.use_age_bands", value: true, not: true },
						step: 5
					},
					{
						name: "min_age",
						label: "Min age",
						type: "number",
						required: true,
						condition: { field: "benefit_amount.spouse.enable_specific_ages", value: true },
						step: 5
					},
					{
						name: "max_age",
						label: "Max Age",
						type: "number",
						required: true,
						condition: { field: "benefit_amount.spouse.enable_specific_ages", value: true },
						step: 5
					},
					// Guaranteed issue
					{
						name: "has_guaranteed_issue",
						label: "Has guaranteed issue for Spouse?",
						type: "checkbox",
						step: 5
					},
					{
						name: "guaranteed_issue_amount",
						label: "Guaranteed Issue Amount",
						type: "number",
						condition: { field: "benefit_amount.spouse.has_guaranteed_issue", value: true },
						step: 5
					},

					// Simplified issue
					{
						name: "has_simplified_issue",
						label: "Has simplified issue for Spouse?",
						type: "checkbox",
						step: 5
					},
					{
						name: "simplified_issue_amount",
						label: "Simplified Issue Amount",
						type: "number",
						condition: { field: "benefit_amount.spouse.has_simplified_issue", value: true },
						step: 5
					},

					{
						name: "has_si_questions",
						label: "Has simplified issue health questions for (spouse)?",
						type: "checkbox",
						condition: { field: "benefit_amount.spouse.has_simplified_issue", value: true },
						step: 5
					},
					{
						name: "si_questions",
						label: "SI health question nodes",
						type: "questions",
						required: true,
						condition: { field: "benefit_amount.spouse.has_si_questions", value: true },
						step: 5
					}
				]
			},

			{
				name: "child",
				type: "meta",
				label: "Children",
				// is_present: true,
				// is_visible_in_form: true,
				condition: [
					{ field: "dependent_eligibility.eligible_relationship", includes: "CHILD" },
					{ field: "benefit_amount.is_each_member_has_different_benefit_amount", value: true },
					{ field: "coverage_for", includes: "Children Only" }
				],
				conditionOperator: "AND",

				step: 5,
				fields: [
					{
						name: "is_premium_depends_on_smoke",
						label: "Does the premium depend on whether you smoke?",
						type: "checkbox",
						// is_present: false,
						// is_visible_in_form: true,
						step: 5
					},
					{
						name: "child_can_enroll_individually",
						label: "Does child indivisually enroll in this plan?",
						type: "checkbox",
						// is_present: false,
						// is_visible_in_form: true,
						step: 5
					},

					{
						name: "use_predefine_benefit",
						label: "Do you have specific predefined benefit amounts (Child)?",
						type: "checkbox",
						condition: { field: "benefit_amount.child.enable_specific_benefit", value: true, not: true },
						step: 5
					},
					{
						name: "enable_specific_benefit",
						label: "Does this plan contain an exact benefit amount (Child)?",
						type: "checkbox",
						condition: { field: "benefit_amount.child.use_predefine_benefit", value: true, not: true },
						step: 5
					},
					{
						name: "min_benefit",
						label: "Min Benefit (Child)",
						condition: {
							field: "benefit_amount.child.use_predefine_benefit",
							value: true
						},
						required: true,
						type: "number",
						step: 3
					},
					{
						name: "each_benefit_multiply_by",

						condition: {
							field: "benefit_amount.child.use_predefine_benefit",
							value: true
						},
						label: "Step (Child)",
						type: "number",
						step: 3
					},
					{
						name: "max_benefit",
						condition: {
							field: "benefit_amount.child.use_predefine_benefit",
							value: true
						},
						label: "Max Benefit (Child)",
						required: true,
						type: "number",
						step: 3
					},
					{
						name: "options",
						condition: {
							field: "benefit_amount.child.enable_specific_benefit",
							value: true
						},
						required: true,
						label: "Predefined benefit options(Child)",
						type: "array",
						step: 3
					},
					// Salary
					{
						name: "is_benefit_based_on_salary",
						label: "Is Child benefit based on salary?",
						type: "checkbox",
						step: 5
					},
					{
						name: "salary_multiplier",
						label: "Salary Multiplier (Child)",
						type: "number",
						condition: { field: "benefit_amount.child.is_benefit_based_on_salary", value: true },
						step: 5
					},
					{
						name: "salary_multiplier_max_cap",
						label: "Maximum Benefit Cap on Salary Multiplier (Child)",
						type: "number",
						condition: { field: "benefit_amount.child.is_benefit_based_on_salary", value: true },
						step: 5
					},
					{
						name: "can_child_benefit_exceed_employee",
						label: "Can Child benefit exceed employee benefit?",
						type: "checkbox",
						step: 5
					},
					// Age eligibility
					{
						name: "premium_depend_on_age",
						label: "Does this plan premium depndent on the Child age?",
						condition: { field: "benefit_amount.child.enable_specific_ages", value: true, not: true },
						type: "checkbox",
						step: 4
					},
					{
						name: "use_age_bands",
						label: "Does this plan contain predefined age bands (Child)?",
						condition: [
							{ field: "benefit_amount.child.enable_specific_ages", value: true, not: true },
							{ field: "benefit_amount.child.premium_depend_on_age", value: true }
						],
						conditionOperator: "AND",
						type: "checkbox",
						step: 4
					},
					{
						name: "age_band_ranges",
						label: "Enter the predefined age bands (Child)",
						type: "array",
						condition: { field: "benefit_amount.child.use_age_bands", value: true },
						required: true,
						step: 4
					},
					{
						name: "enable_specific_ages",
						label: "Does this plan contain exact ages (Child)?",
						type: "checkbox",
						condition: { field: "benefit_amount.child.use_age_bands", value: true, not: true },
						step: 4
					},
					{
						name: "min_age",
						label: "Min age (Child)",
						type: "number",
						required: true,
						condition: { field: "benefit_amount.child.enable_specific_ages", value: true },
						step: 4
					},
					{
						name: "max_age",
						label: "Max Age (Child)",
						type: "number",
						required: true,
						condition: { field: "benefit_amount.child.enable_specific_ages", value: true },
						step: 4
					},
					// Guaranteed issue
					{
						name: "has_guaranteed_issue",
						label: "Has guaranteed issue for child?",
						type: "checkbox",
						step: 3
					},
					{
						name: "guaranteed_issue_amount",
						label: "Guaranteed Issue Amount",
						type: "number",
						condition: { field: "benefit_amount.child.has_guaranteed_issue", value: true },
						step: 5
					},

					// Simplified issue
					{
						name: "has_simplified_issue",
						label: "Has simplified issue for Child?",
						type: "checkbox",
						step: 5
					},
					{
						name: "simplified_issue_amount",
						label: "Simplified Issue Amount",
						type: "number",
						condition: { field: "benefit_amount.child.has_simplified_issue", value: true },
						step: 5
					},

					{
						name: "has_si_questions",
						label: "Has simplified issue health questions for (Child)?",
						type: "checkbox",
						condition: { field: "benefit_amount.child.has_simplified_issue", value: true },
						step: 5
					},
					{
						name: "si_questions",
						label: "SI health question nodes",
						type: "questions",
						required: true,
						condition: { field: "benefit_amount.child.has_si_questions", value: true },
						step: 5
					}
				]
			},
			{
				name: "spose_and_child",
				type: "meta",
				label: "Spouse and child",
				condition: [
					{ field: "dependent_eligibility.eligible_relationship", includes: "CHILD" },
					{ field: "dependent_eligibility.eligible_relationship", includes: "SPOUSE" },
					{ field: "coverage_for", includes: "Spouse & Children" },

					{ field: "benefit_amount.is_each_member_has_different_benefit_amount", value: true }
				],
				conditionOperator: "AND",

				step: 5,
				fields: [
					{
						name: "use_employee_benefit",
						label: "Does you wnat to use employee benefit",
						type: "checkbox",
						// condition: { field: "benefit_amount.use_predefine_benefit", value: true, not: true },
						step: 5
					},
					{
						name: "use_spouse_benefit",
						label: "Does you wnat to use spouse benefit",
						type: "checkbox",
						// condition: { field: "benefit_amount.use_predefine_benefit", value: true, not: true },
						step: 5
					},
					{
						name: "use_child_benefit",
						label: "Does you wnat to use child benefit",
						type: "checkbox",
						// condition: { field: "benefit_amount.use_predefine_benefit", value: true, not: true },
						step: 5
					},
					{
						name: "use_seperate_benefit",
						label: "Does you wnat to use seperate benefit",
						type: "checkbox",
						// condition: { field: "benefit_amount.use_predefine_benefit", value: true, not: true },
						step: 5
					},
					{
						name: "enable_specific_benefit",
						label: "Does this plan contain an exact benefit amount?",
						type: "checkbox",
						condition: {
							field: "benefit_amount.spose_and_child.use_predefine_benefit",
							value: true,
							not: true
						},
						step: 5
					},
					{
						name: "min_benefit",
						label: "Min Benefit",
						type: "number",
						required: true,
						condition: { field: "benefit_amount.spose_and_child.enable_specific_benefit", value: true },
						step: 5
					},
					{
						name: "each_benefit_multiply_by",
						label: "Step",
						type: "number",
						condition: { field: "benefit_amount.spose_and_child.enable_specific_benefit", value: true },
						step: 5
					},
					{
						name: "max_benefit",
						label: "Max Benefit",
						type: "number",
						required: true,
						condition: { field: "benefit_amount.spose_and_child.enable_specific_benefit", value: true },
						step: 5
					},
					{
						name: "benefit_amount_round_to_nearest",
						label: "Round benefit amount to nearest (e.g. 1000)",
						type: "number",
						condition: { field: "benefit_amount.spose_and_child.enable_specific_benefit", value: true },
						step: 5
					},

					{
						name: "use_predefine_benefit",
						label: "Do you have specific predefined benefit amounts?",
						type: "checkbox",
						condition: {
							field: "benefit_amount.spose_and_child.enable_specific_benefit",
							value: true,
							not: true
						},
						step: 5
					},
					{
						name: "benefit_band_ranges",
						label: "Enter the predefined benefit amounts",
						type: "array",
						required: true,
						condition: { field: "benefit_amount.spose_and_child.use_predefine_benefit", value: true },
						step: 5
					}
				]
			}
		]
	},
	{
		name: "is_benefit_dependent_on_paycheck",
		label: "Is the benefit amount dependent on the employee's paycheck for employee?",
		condition: { field: "is_benefit", value: true },
		type: "checkbox",
		required: false,
		is_present: true,
		is_visible_in_form: true,
		step: 5
	},

	{
		name: "has_guaranteed_issue",
		label: "Does this plan have a guaranteed issue amount for employee?",
		type: "checkbox",
		condition: { field: "is_benefit", value: true },
		required: false,
		is_present: true,
		is_visible_in_form: true,
		step: 5
	},
	{
		name: "guaranteed_issue_amount",
		label: "Guaranteed Issue Amount",
		type: "number",
		required: true,
		condition: { field: "has_guaranteed_issue", value: true },
		is_present: true,
		is_visible_in_form: true,
		step: 5
	},

	{
		name: "has_simplified_issue",
		label: "Does this plan have a simplified issue amount for employee?",
		type: "checkbox",
		condition: { field: "is_benefit", value: true },
		required: false,
		is_present: true,
		is_visible_in_form: true,
		step: 5
	},
	{
		name: "simplified_issue_amount",
		label: "Simplified Issue Amount",
		type: "number",
		required: true,
		condition: { field: "has_simplified_issue", value: true },
		is_present: true,
		is_visible_in_form: true,
		step: 5
	},

	{
		name: "has_si_questions",
		label: "Does this plan have health questions to ask the employee for simplified issue?",
		type: "checkbox",
		required: false,
		condition: { field: "has_simplified_issue", value: true },
		is_present: true,
		is_visible_in_form: true,
		step: 5
	},
	{
		name: "si_questions",
		label: "Enter the health questions for simplified issue",
		type: "questions",
		required: true,
		condition: { field: "has_si_questions", value: true },
		is_present: true,
		is_visible_in_form: true,
		step: 5
	},

	{
		name: "is_this_plan_has_riders",
		label: "Does this plan include rider?",
		type: "checkbox",
		is_present: true,
		is_visible_in_form: true,
		step: 6
	},
	{
		name: "rider",
		type: "meta",
		is_present: false,
		is_visible_in_form: true,
		condition: { field: "is_this_plan_has_riders", value: true },
		step: 6,
		fields: [
			// ── Basic Info ──
			{ name: "name", label: "Rider Name", type: "text", required: true, step: 6 },
			{
				name: "is_rider_only_for_employee",
				label: "Rider Only for Employee",
				type: "checkbox",
				condition: { field: "rider.is_rider_has_same_base_plan_coverage_for", value: true, not: true },
				step: 6
			},
			{
				name: "is_rider_has_same_base_plan_coverage_for",
				label: "Is rider have same base plan coverage for?",
				type: "checkbox",
				condition: { field: "rider.is_rider_only_for_employee", value: true, not: true },
				step: 6
			},
			{ name: "is_required", label: "Is Required", type: "checkbox", step: 6 },

			// ── Coverage ──
			{
				name: "indenpendent_relationship",
				label: "Does every relationship can enroll independently in this rider?",
				type: "checkbox",
				required: false,
				step: 6
			},
			{
				name: "employee_require",
				label: "Does employee have to enroll in this rider?",
				type: "checkbox",
				required: false,
				step: 6
			},
			{
				name: "coverage_for",
				label: "Who should be covered by this rider?",
				type: "multiselect",
				required: true,
				options: [
					"Employee Only",
					"Spouse Only",
					"Children Only",
					"Employee & Spouse",
					"Employee & Children",
					"Employee & Family",
					"Spouse & Children"
				],
				step: 6
			},
			{
				name: "coverage_volume_present",
				label: "Do you have the coverage volume?",
				type: "checkbox",
				step: 6
			},
			{
				name: "coverage_volume",
				label: "Rider Coverage Volume",
				type: "array",
				required: true,
				condition: { field: "rider.coverage_volume_present", value: true },
				step: 6
			},
			{
				name: "coverage_volume_same_as_employee",
				label: "Does each relation have to take same coverage volume as employee?",
				condition: { field: "rider.coverage_volume_present", value: true },
				type: "checkbox",
				required: true,
				step: 6
			},
			{
				name: "pay_frequency",
				label: "How often would you like this rider to be paid?",
				type: "multiselect",
				options: ["WEEKLY", "BIWEEKLY", "MONTHLY"],
				required: true,
				step: 6
			},
			{
				name: "is_premium_depends_on_smoke",
				label: "Does the premium depend on whether you smoke?",
				type: "checkbox",
				step: 6
			},

			// ── Dependent Eligibility ──
			{
				name: "isdependent_eligibility",
				label: "Are dependents eligible under this rider?",
				type: "checkbox",
				step: 6
			},
			{
				name: "Beneficiaries",
				label: "Does this plan need Beneficiaries?",
				type: "checkbox",
				// required: false,
				// is_present: true,
				// is_visible_in_form: true,
				step: 1
			},
			{
				name: "dependent_eligibility",
				label: "Dependent Eligibility",
				type: "meta",
				condition: { field: "rider.isdependent_eligibility", value: true },
				step: 6,
				fields: [
					{
						name: "eligible_relationship",
						label: "Select relationships eligible for this rider",
						type: "multiselect",
						options: ["SPOUSE", "CHILD", "STEP CHILD", "COURT-ORDER-DEPENDENT", "GRANDCHILD"],
						required: true,
						step: 6
					},
					{
						name: "spouse",
						label: "Spouse",
						type: "meta",
						condition: { field: "rider.dependent_eligibility.eligible_relationship", includes: "SPOUSE" },
						step: 6,
						fields: [
							{ name: "min_age", label: "Min Age", type: "number", defaultValue: 18, step: 6 },
							{ name: "max_age", label: "Max Age", type: "number", defaultValue: 100, step: 6 },
							{
								name: "can_spouse_has_max_benefit_amount_than_employee",
								label: "Can the spouse's benefit exceed the employee's benefit?",
								type: "checkbox",
								condition: { field: "rider.is_benefit", value: true },
								step: 6
							}
						]
					},
					{
						name: "children",
						label: "Children",
						type: "meta",
						condition: { field: "rider.dependent_eligibility.eligible_relationship", includes: "CHILD" },
						required: true,
						step: 6,
						fields: [
							{ name: "min_age", label: "Min Age", type: "number", defaultValue: 0, step: 6 },
							{ name: "max_age", label: "Max Age", type: "number", defaultValue: 26, step: 6 },
							{
								name: "can_children_has_max_benefit_amount_than_employee",
								label: "Can a child's benefit exceed the employee's benefit?",
								type: "checkbox",
								condition: { field: "rider.is_benefit", value: true },
								step: 6
							}
						]
					},
					{
						name: "disabled",
						label: "Disabled Children Details",
						type: "meta",
						condition: { field: "rider.dependent_eligibility.eligible_relationship", includes: "CHILD" },
						step: 6,
						fields: [
							{ name: "min_age", label: "Min Age", type: "number", defaultValue: 0, step: 6 },
							{ name: "max_age", label: "Max Age", type: "number", defaultValue: 100, step: 6 },
							{
								name: "children_can_exceed_employee_benefit",
								label: "Can a disabled child's benefit exceed the employee's benefit?",
								type: "checkbox",
								condition: { field: "rider.is_benefit", value: true },
								step: 6
							}
						]
					}
				]
			},

			// ── Employee Eligibility ──
			{
				name: "employee_eligibility",
				label: "Enter the eligibility of the employee",
				type: "meta",
				step: 6,
				fields: [
					{ name: "min_age", label: "Min Age", type: "number", defaultValue: 16, step: 6 },
					{ name: "max_age", label: "Max Age", type: "number", defaultValue: 100, step: 6 }
				]
			},

			// ── Age Criteria ──
			{
				name: "is_this_plan_has_age_criteria",
				label: "Does this rider have age-based eligibility criteria?",
				type: "checkbox",
				step: 6
			},
			{
				name: "age_criteria",
				type: "meta",
				label: "Age Criteria",
				condition: { field: "rider.is_this_plan_has_age_criteria", value: true },
				step: 6,
				fields: [
					{
						name: "use_age_bands",
						label: "Does this rider contain predefined age bands?",
						type: "checkbox",
						condition: { field: "rider.age_criteria.enable_specific_ages", value: true, not: true },
						step: 6
					},
					{
						name: "age_band_ranges",
						label: "Enter the predefined age bands",
						type: "array",
						required: true,
						condition: { field: "rider.age_criteria.use_age_bands", value: true },
						step: 6
					},
					{
						name: "enable_specific_ages",
						label: "Does this rider contain exact ages?",
						type: "checkbox",
						condition: { field: "rider.age_criteria.use_age_bands", value: true, not: true },
						step: 6
					},
					{
						name: "min_age",
						label: "Min Age",
						type: "number",
						required: true,
						condition: { field: "rider.age_criteria.enable_specific_ages", value: true },
						step: 6
					},
					{
						name: "max_age",
						label: "Max Age",
						type: "number",
						required: true,
						condition: { field: "rider.age_criteria.enable_specific_ages", value: true },
						step: 6
					}
				]
			},

			// ── Benefit Amount ──
			{
				name: "is_benefit",
				label: "Does this rider include a benefit amount?",
				type: "checkbox",
				step: 6
			},
			{
				name: "benefit_amount",
				type: "meta",
				label: "Benefit Amount",
				condition: { field: "rider.is_benefit", value: true },
				step: 6,
				fields: [
					{
						name: "enable_specific_benefit",
						label: "Does this rider contain an exact benefit amount?",
						type: "checkbox",
						condition: { field: "rider.benefit_amount.use_predefine_benefit", value: true, not: true },
						step: 6
					},
					{
						name: "min_benefit",
						label: "Min Benefit",
						type: "number",
						required: true,
						condition: { field: "rider.benefit_amount.enable_specific_benefit", value: true },
						step: 6
					},
					{
						name: "each_benefit_multiply_by",
						label: "Step",
						type: "number",
						condition: { field: "rider.benefit_amount.enable_specific_benefit", value: true },
						step: 6
					},
					{
						name: "max_benefit",
						label: "Max Benefit",
						type: "number",
						required: true,
						condition: { field: "rider.benefit_amount.enable_specific_benefit", value: true },
						step: 6
					},
					{
						name: "benefit_amount_round_to_nearest",
						label: "Round benefit amount to nearest (e.g. 1000)",
						type: "number",
						condition: { field: "rider.benefit_amount.enable_specific_benefit", value: true },
						step: 6
					},
					{
						name: "use_predefine_benefit",
						label: "Do you have specific predefined benefit amounts?",
						type: "checkbox",
						condition: { field: "rider.benefit_amount.enable_specific_benefit", value: true, not: true },
						step: 6
					},
					{
						name: "benefit_band_ranges",
						label: "Enter the predefined benefit amounts",
						type: "array",
						required: true,
						condition: { field: "rider.benefit_amount.use_predefine_benefit", value: true },
						step: 6
					},

					// ── Salary ──
					{
						name: "is_benefit_based_on_salary",
						label: "Is the benefit amount based on employee salary?",
						type: "checkbox",
						step: 6
					},
					{
						name: "is_benefit_amount_based_on_yearly_salary_percentage",
						label: "Use a percentage of annual salary",
						type: "checkbox",
						condition: [
							{ field: "rider.benefit_amount.is_benefit_based_on_salary", value: true },
							{
								field: "rider.benefit_amount.is_benefit_amount_based_on_yearly_salary_multiplier",
								value: true,
								not: true
							}
						],
						step: 6
					},
					{
						name: "salary_percentage",
						label: "Salary Percentage (e.g. 50 = 50% of annual salary)",
						type: "number",
						required: true,
						condition: {
							field: "rider.benefit_amount.is_benefit_amount_based_on_yearly_salary_percentage",
							value: true
						},
						step: 6
					},
					{
						name: "is_benefit_amount_based_on_yearly_salary_multiplier",
						label: "Use a multiplier of annual salary",
						type: "checkbox",
						condition: [
							{ field: "rider.benefit_amount.is_benefit_based_on_salary", value: true },
							{
								field: "rider.benefit_amount.is_benefit_amount_based_on_yearly_salary_percentage",
								value: true,
								not: true
							}
						],
						conditionOperator: "AND",
						step: 6
					},
					{
						name: "yearly_salary_multiplier",
						label: "Salary Multiplier (e.g. 1 = 1× annual salary)",
						type: "number",
						required: true,
						condition: {
							field: "rider.benefit_amount.is_benefit_amount_based_on_yearly_salary_multiplier",
							value: true
						},
						step: 6
					},
					{
						name: "salary_multiplier_max_cap",
						label: "Maximum Benefit Cap on Salary Multiplier",
						type: "number",
						condition: {
							field: "rider.benefit_amount.is_benefit_amount_based_on_yearly_salary_multiplier",
							value: true
						},
						step: 6
					},

					// ── Per-relation benefit ──
					{
						name: "is_each_member_has_different_benefit_amount",
						label: "Does each relation have a different benefit amount or age criteria?",
						type: "checkbox",
						condition: [
							{ field: "rider.dependent_eligibility.eligible_relationship", includes: "SPOUSE" },
							{ field: "rider.dependent_eligibility.eligible_relationship", includes: "CHILD" }
						],
						conditionOperator: "OR",
						step: 6
					},

					// ── Spouse Benefit ──
					{
						name: "spouse",
						type: "meta",
						label: "Spouse",
						condition: [
							{ field: "rider.dependent_eligibility.eligible_relationship", includes: "SPOUSE" },
							{ field: "rider.benefit_amount.is_each_member_has_different_benefit_amount", value: true }
						],
						conditionOperator: "AND",
						step: 6,
						fields: [
							{
								name: "is_premium_depends_on_smoke",
								label: "Does the premium depend on smoke?",
								type: "checkbox",
								step: 6
							},
							{
								name: "spouse_can_enroll_individually",
								label: "Does Spouse individually enroll in this rider?",
								type: "checkbox",
								step: 6
							},
							{
								name: "use_predefine_benefit",
								label: "Do you have specific predefined benefit amounts?",
								type: "checkbox",
								condition: {
									field: "rider.benefit_amount.spouse.enable_specific_benefit",
									value: true,
									not: true
								},
								step: 6
							},
							{
								name: "enable_specific_benefit",
								label: "Does this rider contain an exact benefit amount?",
								type: "checkbox",
								condition: {
									field: "rider.benefit_amount.spouse.use_predefine_benefit",
									value: true,
									not: true
								},
								step: 6
							},
							{
								name: "min_benefit",
								label: "Min Benefit (Spouse)",
								type: "number",
								required: true,
								condition: { field: "rider.benefit_amount.spouse.use_predefine_benefit", value: true },
								step: 6
							},
							{
								name: "each_benefit_multiply_by",
								label: "Step (Spouse)",
								type: "number",
								required: true,
								condition: { field: "rider.benefit_amount.spouse.use_predefine_benefit", value: true },
								step: 6
							},
							{
								name: "max_benefit",
								label: "Max Benefit (Spouse)",
								type: "number",
								required: true,
								condition: { field: "rider.benefit_amount.spouse.use_predefine_benefit", value: true },
								step: 6
							},
							{
								name: "options",
								label: "Predefined benefit options (Spouse)",
								type: "array",
								required: true,
								condition: {
									field: "rider.benefit_amount.spouse.enable_specific_benefit",
									value: true
								},
								step: 6
							},
							// Salary
							{
								name: "is_benefit_based_on_salary",
								label: "Is spouse benefit based on salary?",
								type: "checkbox",
								step: 6
							},
							{
								name: "salary_multiplier",
								label: "Salary Multiplier (Spouse)",
								type: "number",
								condition: {
									field: "rider.benefit_amount.spouse.is_benefit_based_on_salary",
									value: true
								},
								step: 6
							},
							{
								name: "salary_multiplier_max_cap",
								label: "Maximum Benefit Cap on Salary Multiplier (Spouse)",
								type: "number",
								condition: {
									field: "rider.benefit_amount.spouse.is_benefit_based_on_salary",
									value: true
								},
								step: 6
							},
							{
								name: "can_spouse_benefit_exceed_employee",
								label: "Can spouse benefit exceed employee benefit?",
								type: "checkbox",
								step: 6
							},
							// Age eligibility
							{
								name: "premium_depend_on_age",
								label: "Does this rider premium dependent on the spouse age?",
								type: "checkbox",
								condition: {
									field: "rider.benefit_amount.spouse.enable_specific_ages",
									value: true,
									not: true
								},
								step: 6
							},
							{
								name: "use_age_bands",
								label: "Does this rider contain predefined age bands?",
								type: "checkbox",
								condition: [
									{
										field: "rider.benefit_amount.spouse.enable_specific_ages",
										value: true,
										not: true
									},
									{ field: "rider.benefit_amount.spouse.premium_depend_on_age", value: true }
								],
								conditionOperator: "AND",
								step: 6
							},
							{
								name: "age_band_ranges",
								label: "Enter the predefined age bands",
								type: "array",
								required: true,
								condition: { field: "rider.benefit_amount.spouse.use_age_bands", value: true },
								step: 6
							},
							{
								name: "enable_specific_ages",
								label: "Does this rider contain exact ages?",
								type: "checkbox",
								condition: {
									field: "rider.benefit_amount.spouse.use_age_bands",
									value: true,
									not: true
								},
								step: 6
							},
							{
								name: "min_age",
								label: "Min Age",
								type: "number",
								required: true,
								condition: { field: "rider.benefit_amount.spouse.enable_specific_ages", value: true },
								step: 6
							},
							{
								name: "max_age",
								label: "Max Age",
								type: "number",
								required: true,
								condition: { field: "rider.benefit_amount.spouse.enable_specific_ages", value: true },
								step: 6
							},
							// GI
							{
								name: "has_guaranteed_issue",
								label: "Has guaranteed issue for Spouse?",
								type: "checkbox",
								step: 6
							},
							{
								name: "guaranteed_issue_amount",
								label: "Guaranteed Issue Amount",
								type: "number",
								condition: { field: "rider.benefit_amount.spouse.has_guaranteed_issue", value: true },
								step: 6
							},
							// SI
							{
								name: "has_simplified_issue",
								label: "Has simplified issue for Spouse?",
								type: "checkbox",
								step: 6
							},
							{
								name: "simplified_issue_amount",
								label: "Simplified Issue Amount",
								type: "number",
								condition: { field: "rider.benefit_amount.spouse.has_simplified_issue", value: true },
								step: 6
							},
							{
								name: "has_si_questions",
								label: "Has simplified issue health questions for (Spouse)?",
								type: "checkbox",
								condition: { field: "rider.benefit_amount.spouse.has_simplified_issue", value: true },
								step: 6
							},
							{
								name: "si_questions",
								label: "SI health question nodes",
								type: "questions",
								required: true,
								condition: { field: "rider.benefit_amount.spouse.has_si_questions", value: true },
								step: 6
							}
						]
					},

					// ── Child Benefit ──
					{
						name: "child",
						type: "meta",
						label: "Children",
						condition: [
							{ field: "rider.dependent_eligibility.eligible_relationship", includes: "CHILD" },
							{ field: "rider.benefit_amount.is_each_member_has_different_benefit_amount", value: true }
						],
						conditionOperator: "AND",
						step: 6,
						fields: [
							{
								name: "is_premium_depends_on_smoke",
								label: "Does the premium depend on whether you smoke?",
								type: "checkbox",
								step: 6
							},
							{
								name: "child_can_enroll_individually",
								label: "Does child individually enroll in this rider?",
								type: "checkbox",
								step: 6
							},
							{
								name: "use_predefine_benefit",
								label: "Do you have specific predefined benefit amounts (Child)?",
								type: "checkbox",
								condition: {
									field: "rider.benefit_amount.child.enable_specific_benefit",
									value: true,
									not: true
								},
								step: 6
							},
							{
								name: "enable_specific_benefit",
								label: "Does this rider contain an exact benefit amount (Child)?",
								type: "checkbox",
								condition: {
									field: "rider.benefit_amount.child.use_predefine_benefit",
									value: true,
									not: true
								},
								step: 6
							},
							{
								name: "min_benefit",
								label: "Min Benefit (Child)",
								type: "number",
								required: true,
								condition: { field: "rider.benefit_amount.child.use_predefine_benefit", value: true },
								step: 6
							},
							{
								name: "each_benefit_multiply_by",
								label: "Step (Child)",
								type: "number",
								condition: { field: "rider.benefit_amount.child.use_predefine_benefit", value: true },
								step: 6
							},
							{
								name: "max_benefit",
								label: "Max Benefit (Child)",
								type: "number",
								required: true,
								condition: { field: "rider.benefit_amount.child.use_predefine_benefit", value: true },
								step: 6
							},
							{
								name: "options",
								label: "Predefined benefit options (Child)",
								type: "array",
								required: true,
								condition: { field: "rider.benefit_amount.child.enable_specific_benefit", value: true },
								step: 6
							},
							// Salary
							{
								name: "is_benefit_based_on_salary",
								label: "Is Child benefit based on salary?",
								type: "checkbox",
								step: 6
							},
							{
								name: "salary_multiplier",
								label: "Salary Multiplier (Child)",
								type: "number",
								condition: {
									field: "rider.benefit_amount.child.is_benefit_based_on_salary",
									value: true
								},
								step: 6
							},
							{
								name: "salary_multiplier_max_cap",
								label: "Maximum Benefit Cap on Salary Multiplier (Child)",
								type: "number",
								condition: {
									field: "rider.benefit_amount.child.is_benefit_based_on_salary",
									value: true
								},
								step: 6
							},
							{
								name: "can_child_benefit_exceed_employee",
								label: "Can Child benefit exceed employee benefit?",
								type: "checkbox",
								step: 6
							},
							// Age eligibility
							{
								name: "premium_depend_on_age",
								label: "Does this rider premium dependent on the Child age?",
								type: "checkbox",
								condition: {
									field: "rider.benefit_amount.child.enable_specific_ages",
									value: true,
									not: true
								},
								step: 6
							},
							{
								name: "use_age_bands",
								label: "Does this rider contain predefined age bands (Child)?",
								type: "checkbox",
								condition: [
									{
										field: "rider.benefit_amount.child.enable_specific_ages",
										value: true,
										not: true
									},
									{ field: "rider.benefit_amount.child.premium_depend_on_age", value: true }
								],
								conditionOperator: "AND",
								step: 6
							},
							{
								name: "age_band_ranges",
								label: "Enter the predefined age bands (Child)",
								type: "array",
								required: true,
								condition: { field: "rider.benefit_amount.child.use_age_bands", value: true },
								step: 6
							},
							{
								name: "enable_specific_ages",
								label: "Does this rider contain exact ages (Child)?",
								type: "checkbox",
								condition: {
									field: "rider.benefit_amount.child.use_age_bands",
									value: true,
									not: true
								},
								step: 6
							},
							{
								name: "min_age",
								label: "Min Age (Child)",
								type: "number",
								required: true,
								condition: { field: "rider.benefit_amount.child.enable_specific_ages", value: true },
								step: 6
							},
							{
								name: "max_age",
								label: "Max Age (Child)",
								type: "number",
								required: true,
								condition: { field: "rider.benefit_amount.child.enable_specific_ages", value: true },
								step: 6
							},
							// GI
							{
								name: "has_guaranteed_issue",
								label: "Has guaranteed issue for Child?",
								type: "checkbox",
								step: 6
							},
							{
								name: "guaranteed_issue_amount",
								label: "Guaranteed Issue Amount",
								type: "number",
								condition: { field: "rider.benefit_amount.child.has_guaranteed_issue", value: true },
								step: 6
							},
							// SI
							{
								name: "has_simplified_issue",
								label: "Has simplified issue for Child?",
								type: "checkbox",
								step: 6
							},
							{
								name: "simplified_issue_amount",
								label: "Simplified Issue Amount",
								type: "number",
								condition: { field: "rider.benefit_amount.child.has_simplified_issue", value: true },
								step: 6
							},
							{
								name: "has_si_questions",
								label: "Has simplified issue health questions for (Child)?",
								type: "checkbox",
								condition: { field: "rider.benefit_amount.child.has_simplified_issue", value: true },
								step: 6
							},
							{
								name: "si_questions",
								label: "SI health question nodes",
								type: "questions",
								required: true,
								condition: { field: "rider.benefit_amount.child.has_si_questions", value: true },
								step: 6
							}
						]
					},

					// ── Spouse & Child Benefit ──
					{
						name: "spouse_and_child",
						type: "meta",
						label: "Spouse and Child",
						condition: [
							{ field: "rider.dependent_eligibility.eligible_relationship", includes: "CHILD" },
							{ field: "rider.dependent_eligibility.eligible_relationship", includes: "SPOUSE" },
							{ field: "rider.coverage_for", includes: "Spouse & Children" },
							{ field: "rider.benefit_amount.is_each_member_has_different_benefit_amount", value: true }
						],
						conditionOperator: "AND",
						step: 6,
						fields: [
							{
								name: "use_employee_benefit",
								label: "Do you want to use employee benefit?",
								type: "checkbox",
								step: 6
							},
							{
								name: "use_spouse_benefit",
								label: "Do you want to use spouse benefit?",
								type: "checkbox",
								step: 6
							},
							{
								name: "use_child_benefit",
								label: "Do you want to use child benefit?",
								type: "checkbox",
								step: 6
							},
							{
								name: "use_separate_benefit",
								label: "Do you want to use separate benefit?",
								type: "checkbox",
								step: 6
							},
							{
								name: "enable_specific_benefit",
								label: "Does this rider contain an exact benefit amount?",
								type: "checkbox",
								condition: {
									field: "rider.benefit_amount.spouse_and_child.use_predefine_benefit",
									value: true,
									not: true
								},
								step: 6
							},
							{
								name: "min_benefit",
								label: "Min Benefit",
								type: "number",
								required: true,
								condition: {
									field: "rider.benefit_amount.spouse_and_child.enable_specific_benefit",
									value: true
								},
								step: 6
							},
							{
								name: "each_benefit_multiply_by",
								label: "Step",
								type: "number",
								condition: {
									field: "rider.benefit_amount.spouse_and_child.enable_specific_benefit",
									value: true
								},
								step: 6
							},
							{
								name: "max_benefit",
								label: "Max Benefit",
								type: "number",
								required: true,
								condition: {
									field: "rider.benefit_amount.spouse_and_child.enable_specific_benefit",
									value: true
								},
								step: 6
							},
							{
								name: "benefit_amount_round_to_nearest",
								label: "Round benefit amount to nearest (e.g. 1000)",
								type: "number",
								condition: {
									field: "rider.benefit_amount.spouse_and_child.enable_specific_benefit",
									value: true
								},
								step: 6
							},
							{
								name: "use_predefine_benefit",
								label: "Do you have specific predefined benefit amounts?",
								type: "checkbox",
								condition: {
									field: "rider.benefit_amount.spouse_and_child.enable_specific_benefit",
									value: true,
									not: true
								},
								step: 6
							},
							{
								name: "benefit_band_ranges",
								label: "Enter the predefined benefit amounts",
								type: "array",
								required: true,
								condition: {
									field: "rider.benefit_amount.spouse_and_child.use_predefine_benefit",
									value: true
								},
								step: 6
							}
						]
					}
				]
			},

			// ── Paycheck + Employee-level GI/SI (mirrors standard plan exactly) ──
			{
				name: "is_benefit_dependent_on_paycheck",
				label: "Is the benefit amount dependent on the employee's paycheck for employee?",
				condition: { field: "rider.is_benefit", value: true },
				type: "checkbox",
				required: false,
				step: 6
			},
			{
				name: "has_guaranteed_issue",
				label: "Does this rider have a guaranteed issue amount for employee?",
				type: "checkbox",
				condition: { field: "rider.is_benefit", value: true },
				required: false,
				step: 6
			},
			{
				name: "guaranteed_issue_amount",
				label: "Guaranteed Issue Amount",
				type: "number",
				required: true,
				condition: { field: "rider.has_guaranteed_issue", value: true },
				step: 6
			},
			{
				name: "has_simplified_issue",
				label: "Does this rider have a simplified issue amount for employee?",
				type: "checkbox",
				condition: { field: "rider.is_benefit", value: true },
				required: false,
				step: 6
			},
			{
				name: "simplified_issue_amount",
				label: "Simplified Issue Amount",
				type: "number",
				required: true,
				condition: { field: "rider.has_simplified_issue", value: true },
				step: 6
			},
			{
				name: "has_si_questions",
				label: "Does this rider have health questions to ask the employee for simplified issue?",
				type: "checkbox",
				required: false,
				condition: { field: "rider.has_simplified_issue", value: true },
				step: 6
			},
			{
				name: "si_questions",
				label: "Enter the health questions for simplified issue",
				type: "questions",
				required: true,
				condition: { field: "rider.has_si_questions", value: true },
				step: 6
			}
		]
	},

	// ── Plan-level questions ──────────────────────────────────────────────────
	{
		name: "has_questions",
		label: "Does this plan require the employee to answer any questions?",
		type: "checkbox",
		required: false,
		is_present: true,
		is_visible_in_form: true,
		step: 6
	},
	{
		name: "questions",
		label: "Enter the questions for this plan",
		type: "questions",
		condition: { field: "has_questions", value: true },
		required: true,
		is_present: true,
		is_visible_in_form: true,
		step: 6
	},

	{
		name: "upload_excel",
		label: "Upload Premium Excel",
		type: "excelfile",
		accept: ".xlsx,.xls",
		is_present: true,
		required: true,
		is_visible_in_form: true,
		step: 7
	}
];
